// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction, mergeStyleSets } from "@fluentui/react";

export const getFlexMenuClassNames = memoizeFunction(
  (expandMaxHeight: boolean) => {
    return mergeStyleSets({
      container: {
        overflow: "hidden auto",
        paddingTop: 8,
        // In Safari, the scroll bar does not expand the width of the menu, but covers the items.
        // We need to set a width that is enough to put the scroll bar into.
        width: 367, // 330 (item) + 2 (border) + 16 (left margin) + 19 (scroll bar width)
        height: 370,
        selectors: {
          "@media screen and (max-height: 256px)": {
            display: "none",
          },
          img: {
            borderRadius: 4,
          },
        },
      },
      header: {
        padding: "20px 18px 12px",
      },
      footer: {},
      root: {
        display: "flex",
        flexDirection: "column",
        listStyleType: "none",
        maxHeight: expandMaxHeight ? 720 : 504,
      },
    });
  }
);
